import { render, staticRenderFns } from "./DocDetalhados.vue?vue&type=template&id=5408df14&scoped=true&lang=pug&"
import script from "./DocDetalhados.vue?vue&type=script&lang=js&"
export * from "./DocDetalhados.vue?vue&type=script&lang=js&"
import style0 from "./DocDetalhados.vue?vue&type=style&index=0&id=5408df14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408df14",
  null
  
)

export default component.exports